import { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectLocale } from '@/app/slices/appSlice'
import { selectCurrencyCode } from '@/app/slices/organisationSlice'

export function useCurrencyFormatter(props) {
    const { currencyCode, locale, ...options } = props || {}
    const appCurrency = useSelector(selectCurrencyCode)
    const appLocale = useSelector(selectLocale)
    const defaultCurrency = 'USD'
    const defaultLocale = 'en-US'

    const localeToUse = locale || appLocale || defaultLocale
    const currencyCodeToUse = currencyCode || appCurrency || defaultCurrency

    // Callers pass options inline, so compare them by value rather than by reference.
    const optionsKey = JSON.stringify(options)

    const formatter = useMemo(
        () =>
            new Intl.NumberFormat(localeToUse, {
                style: 'currency',
                currency: currencyCodeToUse,
                unitDisplay: 'long',
                signDisplay: 'auto',
                useGrouping: true,
                ...JSON.parse(optionsKey),
            }),
        [localeToUse, currencyCodeToUse, optionsKey]
    )

    const formatCurrency = useCallback(
        (value) => (value != null && !isNaN(value) ? formatter.format(value) : null),

        [formatter]
    )

    return {
        formatCurrency,
        formatter,
    }
}
